import MembersAuth0, { IMembersAuth0 } from '@models/MemberAuth0';
import { api } from '@services';

export interface IRequest {
  search?: string;
}

const getStudioMembersAuth0 = async (
  request: IRequest,
): Promise<IMembersAuth0[]> => {
  const search = request?.search ? request.search : '';
  const { data: members } = await api.get(`/studios/membersAuth0?q=${search}`);

  const _members = MembersAuth0.arrayFromApiModel(members);
  return _members.sort((a, b) => a.roleLevel - b.roleLevel);
};

export { getStudioMembersAuth0 };
